import {
  PAYOUT_SETTING,
  PAYOUT_SETTING_STRIPE_ACCOUNTS,
} from 'utils/StaticApiEndpoints';
import { showErrorAlert, showSuccessAlert } from '../../../utils/AlertUtils';
import requestApi from '../../../utils/Request';
import {
  failurePayoutSettingCreate,
  failurePayoutSettingDelete,
  failurePayoutSettingEdit,
  failurePayoutSettingList,
  failurePayoutSettingToggle,
  failurePayoutSettingView,
  failureStripeAccounts,
  requestPayoutSettingCreate,
  requestPayoutSettingDelete,
  requestPayoutSettingEdit,
  requestPayoutSettingList,
  requestPayoutSettingToggle,
  requestPayoutSettingView,
  requestStripeAccounts,
  responsePayoutSettingCreate,
  responsePayoutSettingDelete,
  responsePayoutSettingEdit,
  responsePayoutSettingList,
  responsePayoutSettingToggle,
  responsePayoutSettingView,
  responseStripeAccounts,
} from '../../slices/payoutSettingSlice/payoutSettingSlice';

export const GetPayoutSettingList = () => {
  return (dispatch) => {
    dispatch(requestPayoutSettingList());
    requestApi
      .get(PAYOUT_SETTING)
      .then((response) => {
        dispatch(responsePayoutSettingList(response));
      })
      .catch((error) => {
        dispatch(failurePayoutSettingList(error));
        showErrorAlert(error?.message || 'Failed to load payout settings');
      });
  };
};

export const CreatePayoutSetting = (payload, callback) => {
  return (dispatch) => {
    dispatch(requestPayoutSettingCreate());
    requestApi
      .post(PAYOUT_SETTING, payload)
      .then(() => {
        dispatch(responsePayoutSettingCreate());
        showSuccessAlert('Payout setting created successfully');
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(failurePayoutSettingCreate(error));
        showErrorAlert(error?.message || 'Failed to create payout setting');
      });
  };
};

export const TogglePayoutSetting = (id, isActive, callback) => {
  return (dispatch) => {
    dispatch(requestPayoutSettingToggle());
    requestApi
      .patch(`${PAYOUT_SETTING}/${id}/toggle`, { isActive })
      .then((response) => {
        dispatch(responsePayoutSettingToggle(response));
        showSuccessAlert(
          `Payout setting ${isActive ? 'activated' : 'deactivated'} successfully`,
        );
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(failurePayoutSettingToggle(error));
        showErrorAlert(
          error?.message || 'Failed to update payout setting status',
        );
      });
  };
};

export const DeletePayoutSetting = (id, callback) => {
  return (dispatch) => {
    dispatch(requestPayoutSettingDelete());
    requestApi
      .delete(`${PAYOUT_SETTING}/${id}`)
      .then(() => {
        dispatch(responsePayoutSettingDelete(id));
        showSuccessAlert('Payout setting deleted successfully');
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(failurePayoutSettingDelete(error));
        showErrorAlert(error?.message || 'Failed to delete payout setting');
      });
  };
};

export const GetPayoutSettingById = (id) => {
  return (dispatch) => {
    dispatch(requestPayoutSettingView());
    requestApi
      .get(`${PAYOUT_SETTING}/${id}`)
      .then((response) => {
        dispatch(responsePayoutSettingView(response));
      })
      .catch((error) => {
        dispatch(failurePayoutSettingView(error));
        showErrorAlert(error?.message || 'Failed to load payout setting');
      });
  };
};

export const UpdatePayoutSetting = (id, payload, callback) => {
  return (dispatch) => {
    dispatch(requestPayoutSettingEdit());
    requestApi
      .put(`${PAYOUT_SETTING}/${id}`, payload)
      .then(() => {
        dispatch(responsePayoutSettingEdit());
        showSuccessAlert('Payout setting updated successfully');
        if (callback) callback();
      })
      .catch((error) => {
        dispatch(failurePayoutSettingEdit(error));
        showErrorAlert(error?.message || 'Failed to update payout setting');
      });
  };
};

export const GetStripeAccounts = () => {
  return (dispatch) => {
    dispatch(requestStripeAccounts());
    requestApi
      .get(PAYOUT_SETTING_STRIPE_ACCOUNTS)
      .then((response) => {
        dispatch(responseStripeAccounts(response));
      })
      .catch((error) => {
        dispatch(failureStripeAccounts(error));
        showErrorAlert(error?.message || 'Failed to load Stripe accounts');
      });
  };
};
